import { useNavigate } from 'react-router-dom';
import { Box, Button, Paper, Typography } from '@mui/material';

const Home = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ p: 3}}>
      <Paper elevation={3} sx={{ p: 3, borderRadius: 2, mx: 'auto' }}>
        <Typography variant="h2" gutterBottom>Aligner Web Portal</Typography>
        <Typography variant="body1" gutterBottom>Cloud based aligner analytics...</Typography>
        <Button sx={{ mt: 2 }} variant="contained" size="large" color="success"
          onClick={() => navigate('/activate')}>Activate</Button>
      </Paper>
    </Box>
  );
};

export default Home;
